export enum EHarvestSaleRequestMetaStatus {
  REQUIRED_DOCUMENTS_NOT_UPLOAD = 'REQUIRED_DOCUMENTS_NOT_UPLOAD',
  REQUEST_FIELDS_REQUIRED = 'REQUEST_FIELDS_REQUIRED',
  SALE_REQUEST_CHANGED = 'SALE_REQUEST_CHANGED',
}
